"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useOutsideClickRef = function useOutsideClickRef(callback) {
  var outsideClickRef = react_1.useRef(null);
  var handleClick = react_1.useCallback(function (event) {
    var isClickInsideElement = outsideClickRef && outsideClickRef.current && outsideClickRef.current.contains(event.target);

    if (isClickInsideElement) {
      return;
    }

    callback();
  }, [callback]);
  react_1.useEffect(function () {
    document.addEventListener('mousedown', handleClick);
    return function () {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick]);
  return outsideClickRef;
};

exports.default = useOutsideClickRef;